import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import Channels from "./components/Channels";
import Directory from "./components/Directory";
import HowToFind from "./components/HowToFind";
import SearchGuide from "./components/SearchGuide";
import Versions from "./components/Versions";
import Faq from "./components/Faq";
import Safety from "./components/Safety";
import SiteFooter from "./components/SiteFooter";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-50 flex h-11 w-11 items-center justify-center rounded-full bg-primary-600 text-background-50 shadow-lg transition-colors hover:bg-primary-700"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <Overview />
        <Channels />
        <Directory />
        <HowToFind />
        <SearchGuide />
        <Versions />
        <Faq />
        <Safety />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}